export default {
    PROFILE: process.env.NODE_ENV,
    API_URL : process.env.VUE_APP_HOST? (process.env.VUE_APP_HOST + (process.env.VUE_APP_PORT?":"+process.env.VUE_APP_PORT : "")):''
}
